import React, { Component } from 'react';
import { injectIntl } from 'react-intl';

import Autosuggest from 'react-autosuggest';
import match from 'autosuggest-highlight/match';
import parse from 'autosuggest-highlight/parse';
import debounce, { getLinkId } from 'Services/tools';

import TextField from '@material-ui/core/TextField';
import Paper from '@material-ui/core/Paper';
import MenuItem from '@material-ui/core/MenuItem';
import InputAdornment from '@material-ui/core/InputAdornment';
import CompetitionIcon from 'Components/icons/Competition';

import { connect } from 'react-redux';
import { fetchTournaments, fetchTournament } from './actions';
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
  container: {
    flexGrow: 1,
    position: 'relative',
  },
  suggestionsContainerOpen: {
    position: 'absolute',
    zIndex: '10',
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(3),
    left: 0,
  },
  suggestion: {
    display: 'block',
  },
  suggestionsList: {
    margin: 0,
    padding: 0,
    listStyleType: 'none',
  },
  textField: {
    width: '100%',
  },
});

@injectIntl
@withStyles(styles)
@connect(store => ({
  suggestions: store.tournaments.list,
}))
export default class TournamentInput extends Component {
  state = {
    searchText: '',
    suggestions: [],
  };

  componentDidMount() {
    const { input, dispatch } = this.props;
    if (input.value) {
      const id = getLinkId(input.value);
      dispatch(fetchTournament(id)).then(data => {
        this.setState({
          searchText: this.getDisplayText(data.payload),
        });
      });
    }
  }

  UNSAFE_componentWillReceiveProps(next) {
    const { input } = this.props;
    if (!next.input || !input) {
      return true;
    }
    if (input.value != next.input.value && !next.input.value) {
      this.setState({ searchText: '' });
    }
  }

  getDisplayText = ({ competitionName, name, competitionAreaSlug }) =>
    `${competitionName} ${name} (${competitionAreaSlug})`;

  handleSuggestionsFetchRequested = debounce(({ value }) => {
    const { dispatch, isActiveOnly } = this.props;
    let search = `&competition.translations.name=${value}`;
    if (isActiveOnly !== false) {
      search = `${search}&isActive=1`;
    }
    dispatch(fetchTournaments(search)).then(
      () => {
        this.setState({
          suggestions: this.getSuggestions(value),
        });
      }
    );
  }, 500);

  handleChange = (event, { newValue }) => {
    this.setState({
      searchText: newValue,
    });
  };
  handleSuggestionSelected = (event, { suggestion }) => {
    this.props.input.onChange(suggestion['@id']);
  };

  renderInput = inputProps => {
    const { classes, value, ref, label, hintText, ...other } = inputProps;
    return (
      <TextField
        className={classes.textField}
        value={value}
        inputRef={ref}
        label={label}
        fullWidth
        InputProps={{
          classes: { input: classes.input },
          placeholder: hintText || label,
          startAdornment: (
            <InputAdornment position="start">
              <CompetitionIcon />
            </InputAdornment>
          ),
          ...other,
        }}
      />
    );
  };
  renderSuggestion = (suggestion, { query, isHighlighted }) => {
    const displayName = this.getDisplayText(suggestion);
    const matches = match(displayName, query);
    const parts = parse(displayName, matches);
    return (
      <MenuItem selected={isHighlighted} component="div">
        <div>
          {parts.map((part, index) =>
            part.highlight ? (
              <span key={index} style={{ fontWeight: 300 }}>
                {part.text}
              </span>
            ) : (
              <strong key={index} style={{ fontWeight: 500 }}>
                {part.text}
              </strong>
            )
          )}
        </div>
      </MenuItem>
    );
  };

  renderSuggestionsContainer = ({ containerProps, children }) => (
    <div>
      {children && (
        <Paper {...containerProps} square>
          {children}
        </Paper>
      )}
    </div>
  );

  handleSuggestionsClearRequested = () => {
    if (this.state.searchText == '') this.props.input.onChange(null);
  };

  getSuggestions = value => {
    const { suggestions } = this.props;
    const inputLength = value.trim().length;
    return inputLength === 0 ? [] : suggestions;
  };

  render() {
    const {
      input,
      labelKey,
      hintText,
      intl: { formatMessage: f },
      classes,
    } = this.props;

    const { searchText, suggestions } = this.state;

    const label = labelKey ? f({ id: labelKey }) : f({ id: `field_${input.name}` });

    return (
      <Autosuggest
        id="tournament"
        theme={{
          container: classes.container,
          suggestionsContainerOpen: classes.suggestionsContainerOpen,
          suggestionsList: classes.suggestionsList,
          suggestion: classes.suggestion,
        }}
        renderInputComponent={this.renderInput}
        suggestions={suggestions}
        onSuggestionsFetchRequested={this.handleSuggestionsFetchRequested}
        onSuggestionsClearRequested={this.handleSuggestionsClearRequested}
        onSuggestionSelected={this.handleSuggestionSelected}
        renderSuggestionsContainer={this.renderSuggestionsContainer}
        getSuggestionValue={this.getDisplayText}
        renderSuggestion={this.renderSuggestion}
        inputProps={{
          value: searchText || '',
          onChange: this.handleChange,
          autoFocus: input.autoFocus,
          name: input.name,
          classes,
          label,
          hintText,
        }}
      />
    );
  }
}
